namespace SSi.Blazor.Common.Shared.Services.AnchorLink {

    export function scrollIntoViewId(elementId) {
        // This function is called from the AnchorLink component using JavaScript interop.
        // It will try to find an element using the ID given to the function, and scroll that
        // element into view, if an element is found.
        var elem = document.getElementById(elementId);
        if (elem) {
            elem.scrollIntoView();
            //window.location.hash = elementId;
        } else {
            console.log("Missing scrollIntoViewId elementId:" + elementId);
        }
    }

    export function scrollIntoViewRef(elementRef) {
        // This function is called from the AnchorLink component using JavaScript interop.
        // It will try to find an element using the ID given to the function, and scroll that
        // element into view, if an element is found.
        if (elementRef) {
            elementRef.scrollIntoView();
            //window.location.hash = `${elementRef.Id}`;
        } else {
            console.log("Missing scrollIntoViewRef elementRef" + elementRef.Id);
        }
    }
}